import { render, staticRenderFns } from "./ordersDeliveryPrintItemSummaryTable.vue?vue&type=template&id=95e7a74e&"
import script from "./ordersDeliveryPrintItemSummaryTable.vue?vue&type=script&lang=ts&"
export * from "./ordersDeliveryPrintItemSummaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports